import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeCanvas } from 'qrcode.react';
import { getHistory, clearHistory } from '../../utils/history';
import { clearState } from '../../utils/localStorage';
import { encodeStateAndHistory } from '../../utils/importExport';

const DataManagement = ({ state }) => {
  const { t } = useTranslation();
  const [showQR, setShowQR] = useState(false);
  const [importUrl, setImportUrl] = useState('');

  function exportProgress() {
    const history = getHistory();
    const base64 = encodeStateAndHistory(state, history);
    const url = window.location.origin + '/#import=' + encodeURIComponent(base64);
    setImportUrl(url);
    setShowQR(true);
  }

  function resetProgress() {
    if (window.confirm('Reset all progress?')) {
      clearState();
      clearHistory();
      window.location.reload();
    }
  }

  return (
    <>
      <div className="pretty-section settings-section">
        <button className="pretty-btn" onClick={exportProgress}>{t('export_progress_qr')}</button>
        {showQR && (
          <div style={{ margin: '1rem 0', textAlign: 'center' }}>
            <QRCodeCanvas value={importUrl} size={200} />
            <div style={{ wordBreak: 'break-all', fontSize: 12, color: '#b85b7b', marginTop: 8 }}>{importUrl}</div>
            <div style={{ color: '#f90', fontSize: 13, marginTop: 8 }}>
              {t('qr_code_notice')}
            </div>
          </div>
        )}
      </div>
      <div className="pretty-section settings-section">
        <button
          className="pretty-btn"
          style={{ background: 'linear-gradient(90deg, #f7a8c7 0%, #f8bfcf 100%)', color: '#fff', fontWeight: 700 }}
          onClick={resetProgress}
        >
          {t('reset_all_progress')}
        </button>
      </div>
    </>
  );
};

export default DataManagement;
